// extracted by mini-css-extract-plugin
module.exports = {"select":"AnnotationFilter_select__2yzcs"};